/* ============================================================
   VAV — Édition 2026 · Theme JS
   ES6 natif, pas de framework
   ============================================================ */

(function() {
  'use strict';

  // ────── Actions VAV (toggle-mode) ──────
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-vav-action="toggle-mode"]');
    if (!trigger) return;
    if (window.VAV && window.VAV.toggleMode) window.VAV.toggleMode();
  });

  // ────── Quick add (cartes livres) ──────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = parseInt(btn.dataset.quickAdd, 10);
    if (!id) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      btn.disabled = false;
      if (window.VAVCart) { window.VAVCart.refresh(); window.VAVCart.open(); }
    })
    .catch(function() { btn.disabled = false; });
  });

  // ────── Reveal au scroll (fallback CSS Scroll-Driven Animations) ──────
  if (!CSS.supports('animation-timeline: scroll()')) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

    document.querySelectorAll('[data-reveal]').forEach(function(el) {
      observer.observe(el);
    });
  }

  console.info('%cVAV — Édition 2026 ✶ Jérusalem · Israël', 'color:#0038B8;font:600 13px/1 sans-serif;letter-spacing:.12em');
})();
